import React, { useEffect } from 'react';
import { hydrateRoot } from 'react-dom/client';
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  RouterProvider,
  useLocation,
  useNavigationType
} from 'react-router-dom';

import * as Sentry from '@sentry/react';
import './index.css';
import { routes } from './routes';

Sentry.init({
  dsn: 'https://8214ccaed5f0735342d90e08d41aab0b@o4506565656117248.ingest.us.sentry.io/4507443009159168',
  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes
    }),
    Sentry.replayIntegration()
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
});

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

const router = sentryCreateBrowserRouter(routes);

// The markup is prerendered at build time (see scripts/prerender.mjs), so hydrate
// the existing #root DOM rather than re-rendering it from scratch.
hydrateRoot(
  document.getElementById('root')!,
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
